// 主要给el-select用
const maxLength = {
  mounted(el, binding) {
    const maxLength = binding.value || 10; // 默认限制为10个字符
    const inputElement = el.querySelector('input'); // 获取实际的输入元素
    if (inputElement) {
      inputElement.addEventListener('input', () => {
        if (inputElement.value.length > maxLength) {
          inputElement.value = inputElement.value.slice(0, maxLength);
          inputElement.dispatchEvent(new Event('input')); // 触发 input 事件以更新 v-model
        }
      });
    }
  }
};
export default maxLength;
